import { useCallback } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import {
  ONBOARDING_SEARCH_PARAM,
  ONBOARDING_VARIANT_SEARCH_PARAM,
} from '@/modules/clientOnboarding/ClientOnboardingDeliverableModal/ClientOnboardingDeliverableSelectionModal.constants';
import { ClientOnboardingDeliverableVariant } from '@/modules/clientOnboarding/types';
import { ROUTE_KEYS } from '@/navigation/constants';

export interface UseEstate360VisualRefreshAnnouncementProps {
  onClose: () => void;
  householdId: string;
}

export function useEstate360VisualRefreshAnnouncement({
  onClose,
  householdId,
}: UseEstate360VisualRefreshAnnouncementProps) {
  const { navigate } = useNavigateToRoute();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleViewSample = useCallback(() => {
    window.open(
      'https://academy.withluminary.com/articles/7063189782-estate360-sample-report',
      '_blank'
    );
  }, []);

  const handleTryItOut = useCallback(() => {
    navigate(
      ROUTE_KEYS.HOUSEHOLD_DETAILS_OVERVIEW,
      { householdId },
      {
        [ONBOARDING_SEARCH_PARAM]: 'true',
        [ONBOARDING_VARIANT_SEARCH_PARAM]:
          ClientOnboardingDeliverableVariant.GENERATE_ESTATE_SNAPSHOT,
      }
    );
    handleClose();
  }, [handleClose, householdId, navigate]);

  return {
    heading: 'Estate360 visual refresh',
    imageUrl: 'estate360-visual-refresh.png',
    imageAlt: 'Estate360 visual refresh',
    bodyText:
      'We’ve done a comprehensive visual refresh of the Estate360 presentation. Every slide has been custom-crafted to help bring the client’s plan to life with your branding at the forefront.',
    actionButtons: (
      <>
        <Button variant="secondary" size="sm" onClick={handleViewSample}>
          View sample
        </Button>
        <Button variant="primary" size="sm" onClick={handleTryItOut}>
          Try it out
        </Button>
      </>
    ),
  };
}
